import { render, staticRenderFns } from "./PneumoniaTable.vue?vue&type=template&id=46e62f41&scoped=true&"
import script from "./PneumoniaTable.vue?vue&type=script&lang=ts&"
export * from "./PneumoniaTable.vue?vue&type=script&lang=ts&"
import style0 from "./PneumoniaTable.vue?vue&type=style&index=0&id=46e62f41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e62f41",
  null
  
)

export default component.exports